export default __webpack_public_path__ + "static/media/logos.8f67c3d7.png";